document.addEventListener("DOMContentLoaded", () => {
  var defaultSecondary = ".product-card__secondary-image:not([data-sibling-id]):not([data-variant-color])";

  function restoreSiblingCard(card) {
    if (!card) return;
    card.querySelectorAll(".product-card__secondary-image[data-sibling-id]").forEach((el) => {
      el.style.visibility = "hidden";
    });
    const primaryImage = card.querySelector(".product-card__featured-image");
    if (primaryImage) primaryImage.style.removeProperty("visibility");
    card.querySelectorAll(defaultSecondary).forEach((el) => {
      el.style.removeProperty("visibility");
    });
  }

  document.querySelectorAll(".sibling-swatch").forEach((swatch) => {
    swatch.addEventListener("click", (event) => {
      const mainId = event.currentTarget.dataset.mainProductId;
      const swatchId = event.currentTarget.dataset.swatchId;
      const card = document.querySelector(`[data-product-card='${mainId}']`);
      if (!card) return;
      card.dataset.clickedSiblingId = swatchId;
      card.querySelectorAll(".product-card__secondary-image[data-sibling-id]").forEach((el) => {
        el.style.visibility = "hidden";
      });
      const si = card.querySelector(`[data-sibling-id='${swatchId}']`);
      if (si) si.style.visibility = "visible";
      const pi = card.querySelector(".product-card__featured-image");
      if (pi) pi.style.visibility = "hidden";
      card.querySelectorAll(defaultSecondary).forEach((el) => {
        el.style.visibility = "hidden";
      });
    });
    swatch.addEventListener("mouseover", (event) => {
      const mainId = event.currentTarget.dataset.mainProductId;
      const swatchId = event.currentTarget.dataset.swatchId;
      const card = document.querySelector(`[data-product-card='${mainId}']`);
      if (!card) return;
      card.querySelectorAll(".product-card__secondary-image[data-sibling-id]").forEach((el) => {
        el.style.visibility = "hidden";
      });
      const secondaryImage = card.querySelector(`[data-sibling-id='${swatchId}']`);
      if (!secondaryImage) return;
      secondaryImage.style.visibility = "visible";
      secondaryImage.classList.add(
        "sm:transition-transform",
        "sm:duration-300",
        "sm:group-hover:scale-[103%]"
      );
      const primaryImage = card.querySelector(".product-card__featured-image");
      if (primaryImage) primaryImage.style.visibility = "hidden";
      card.querySelectorAll(defaultSecondary).forEach((el) => {
        el.style.visibility = "hidden";
      });
    });
  });

  document.querySelectorAll(".primary-swatch").forEach((swatch) => {
    swatch.addEventListener("click", (event) => {
      const sid = event.currentTarget.dataset.swatchId;
      const card = document.querySelector(`[data-product-card='${sid}']`);
      if (!card) return;
      delete card.dataset.clickedSiblingId;
      card.querySelectorAll("[data-sibling-id]").forEach((el) => {
        el.style.visibility = "hidden";
      });
      const pi = card.querySelector(".product-card__featured-image");
      if (pi) pi.style.removeProperty("visibility");
      card.querySelectorAll(defaultSecondary).forEach((el) => {
        el.style.removeProperty("visibility");
      });
    });
    swatch.addEventListener("mouseover", (event) => {
      const sid = event.currentTarget.dataset.swatchId;
      const card = document.querySelector(`[data-product-card='${sid}']`);
      if (!card) return;
      card.querySelectorAll("[data-sibling-id]").forEach((el) => {
        el.style.visibility = "hidden";
      });
      const primaryImage = card.querySelector(".product-card__featured-image");
      if (primaryImage) primaryImage.style.removeProperty("visibility");
      card.querySelectorAll(defaultSecondary).forEach((el) => {
        el.style.removeProperty("visibility");
      });
    });
  });

  document.querySelectorAll("fieldset.swatches").forEach((fieldset) => {
    const card = fieldset.closest("[data-product-card]");
    if (!card || !card.querySelector(".sibling-swatch")) return;
    fieldset.addEventListener("mouseleave", () => {
      if (card.dataset.clickedSiblingId) {
        card.querySelectorAll(".product-card__secondary-image[data-sibling-id]").forEach((el) => {
          el.style.visibility = "hidden";
        });
        const clicked = card.querySelector(`[data-sibling-id='${card.dataset.clickedSiblingId}']`);
        if (clicked) {
          clicked.style.visibility = "visible";
          const pi = card.querySelector(".product-card__featured-image");
          if (pi) pi.style.visibility = "hidden";
          card.querySelectorAll(defaultSecondary).forEach((el) => {
            el.style.visibility = "hidden";
          });
        } else {
          restoreSiblingCard(card);
        }
      } else {
        restoreSiblingCard(card);
      }
    });
  });
});
